module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><path d=\"M11.56 5.56L10.5 4.5 6 9l4.5 4.5 1.06-1.06L8.12 9z\" fill=\"#ffffff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/slider-prev-white.svg
// module id = 134
// module chunks = 1